export const query_anagrafiche_bancaDati_byAnag = `
query getAnagraficheBancaDatiByTenant($anagraficaId: Int!) {
  anagrafica_bancadati(where: {AnagraficaId: {_eq: $anagraficaId}}, order_by: {CreatedOn: desc}) {
    Id
    Repository
    Infos
    CreatedOn
    CreatedBy
  }
}`;